import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CommonServiceContext } from "../services/common/commonService";
import Loader from "../components/Loader";
import RecaptchaComponent from "../components/RecaptchaComponent";
import SearchableSelect from "../components/SearchableSelect";
import CustomCombobox from "../components/CustomCombobox";
import MaskedInput from "react-text-mask";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import {
  IconListDetails,
  IconPackageExport,
  IconPackageImport,
  IconPackage,
  IconUser,
} from "@tabler/icons-react";
import CustomAlert from "../components/CustomAlert";
import TwoFactorModal from "./auth/TwoFactorModal";
import DeliveryAddedModal from "./app/modals/DeliveryAddedModal";
import { useUserContext } from "../context/user_context";
import { AuthServiceContext } from "../services/auth/authService";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

//import GeneratePDF from "../components/GeneratePdf";

const steps = ["მომხმარებლის მონაცემები", "ტვირთის აღწერა", "დადასტურება"];

const DeliveryRequest = () => {
  const {
    loading,
    cities,
    getReferences,
    deliveryOrderTypes,
    packageTypes,
    checkToken,
    peymentMethods,
    deliveryMethods,
    addresses,
    getAddresses,
    priceCalculation,
    getUserFavoriteClients,
    // userFavoriteClients,
    addDeliveryOrder4User,
  } = useContext(CommonServiceContext);
  const { sendSms } = useContext(AuthServiceContext);
  const [iAmType, setIAmType] = useState("1");
  const [selectedOptionSender, setSelectedOptionSender] = useState("1");
  const [selectedOptionReceiver, setSelectedOptionReceiver] = useState("1");
  const [selectedDeliveryOrderType, setSelectedDeliveryOrderType] = useState("");


  const [userFavoriteClients, setUserFavoriteClients] = useState([]);

  const [selectedContact, setSelectedContact] = useState("");
  const [selectedClient, setSelectedClient] = useState("");

  const [selectedSenderClient, setSelectedSenderClient] = useState("");
  const [selectedSenderContact, setSelectedSenderContact] = useState("");


  const [selectedReceiverClient, setSelectedReceiverClient] = useState("");
  const [selectedReceiverContact, setSelectedReceiverContact] = useState("");



  const [updatedCities, setUpdatedCities] = useState([]);
  const [updatedDeliveryOrderTypes, setUpdatedDeliveryOrderTypes] = useState(
    []
  );
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [senderErrors, setSenderErrors] = useState({});
  const [receiverErrors, setReceiverErrors] = useState({});
  const [orderInfoErrors, setOrderInfoErrors] = useState({});
  const [selectedCities, setSelectedCities] = useState({
    senderCityName: "",
    receiverCityName: "",
  });

  const navigate = useNavigate();

  const [clients, setClients] = useState([]);
  const [clientContacts, setClientContacts] = useState([]);
  const [defaultContact, setDefaultContact] = useState([]);

  const [senderContacts, setSenderContacts] = useState([]);
  const [senderClientContacts, setSenderClientContacts] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const [sender, setSender] = useState({
    clientTypeId: "1",
    name: "",
    idNumber: "",
    cityId: "",
    address: "",
    contactName: "",
    contactPhone: "",
  });

  const [receiver, setReceiver] = useState({
    clientTypeId: "1",
    name: "",
    idNumber: "",
    cityId: "",
    address: "",
    contactName: "",
    contactPhone: "",
  });

  const [orderInfo, setOrderInfo] = useState({
    pieceQuantity: "",
    weight: "",
    volumeWeight: "",
    deliveryMethodId: "",
    deliveryOrderTypeId: "",
    paymentMethodId: "",
    payerSideId: 1,
    comment: "",
    insuranceItemPrice: "",
    packageTypeId: 1,
  });

  const [formData, setFormData] = useState({
    smsCode: "",
    mobilePhone: "",
    recaptchaCode: "",
    phoneOrEmail2Subscribe: "",
  });

  const [user, setUser] = useState(null);

  const [openDeliveryAddedModal, setOpenDeliveryAddedModal] = useState(false);

  const [trackingNumber, setTrackingNumber] = useState("");
  const [docUrl, setdocUrl] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState("");

  const [createEventModal, setCreateEventModal] = useState(false);

  const [calculatedPrice, setCalculatedPrice] = useState(0);

  const [updatedContacts, setContacts] = useState([]);

  const [pieces, setPieces] = useState([]);
  const [pieceErrors, setPieceErrors] = useState({});

  const { captchaState, setCaptchaState } = useUserContext();
  const [resetCaptcha, setResetCaptcha] = useState(false);

  const [valueFromChild, setValueFromChild] = useState("");
  const [valueFromChildContact, setValueFromChildContact] = useState("");

  const [valSender, setValSender] = useState("");
  const [valSenderContact, setValSenderContact] = useState("");

  const openDeliveryModal = (trackingNumber, docUrl) => {
    setTrackingNumber(trackingNumber);
    setdocUrl(docUrl);
    setOpenDeliveryAddedModal(true);
  };

  const handleFinalModalClose = () => {
    console.log(isLoggedIn);
    setOpenDeliveryAddedModal(false);

    if (isLoggedIn) {
      navigate("/packages");
    }
    else {
      navigate("/");
    }

  }

  const fetchAddDeliveryOrder = async (updatedSender = sender, updatedReceiver = receiver) => {
    const newPieces =
      orderInfo.packageTypeId == 2
        ? pieces
        : Array.from({ length: orderInfo.pieceQuantity }, () => ({
          length: 0,
          width: 0,
          height: 0,
          pieceVolume: 0,
          pieceNumber: 1,
        }));
    const packageData = {
      sender: updatedSender,
      receiver: updatedReceiver,
      orderInfo: orderInfo,
      pieces: newPieces,
    };

    const data = {
      ...packageData,
      smsCode: formData.smsCode,
      recaptchaCode: captchaState.token,
      mobilePhone: formData.mobilePhone,
    };

    const response = await addDeliveryOrder4User(data);
    //console.log(response);
    if (response && response.data.success) {
      openDeliveryModal(response.data.trackingNumber, response.data.docUrl);
    } else {
      setAlertConfig({
        ...alertConfig,
        icon: "error",
        show: true,
        title: response.data.message || "გზავნილის დამატება ვერ მოხერხდა",
      });
    }
  };

  const fetchUserData = async () => {
    const token = Cookies.get("Token");
    if (!token) return;

    setIsLoading(true);
    //console.log("Token from cookies:", token);

    axios
      .get("https://api365.geoexpress.ge/api/Home", {
        headers: {
          token: `${token}`,
        },
      })
      .then((response) => {
        //console.log("User data fetched successfully:", response.data);
        setUser(response.data.user);
        setIsLoading(false);
      })
      .catch((error) => {
        //console.error("Error fetching user data:", error);
        setIsLoading(false);
      });
  };

  const fetchReferences = async () => {
    //await getCities();
    getReferences();
  };

  const fetchToken = async () => {
    const response = await checkToken();
    //console.log(response);
    setIsLoggedIn(response);
  };

  const fetchAddresses = async (data) => {
    await getAddresses();
  };

  const fetchUserFavoriteClients = async () => {
    let response = await getUserFavoriteClients();
    if (response && response.data) {
      setUserFavoriteClients(response.data);
    }
    else {
      setUserFavoriteClients([]);
    }
  };

  const fetchPriceCalculation = async () => {


    var maxWeight = orderInfo.weight > orderInfo.volumeWeight
      ? orderInfo.weight
      : orderInfo.volumeWeight;

    const sendData = {
      senderCityId: sender.cityId,
      receiverCityId: receiver.cityId,
      deliveryMethodId: orderInfo.deliveryMethodId,
      deliveryOrderTypeId: orderInfo.deliveryOrderTypeId,
      weight: maxWeight,
      estimatePrice: orderInfo.insuranceItemPrice,
    };

    const response = await priceCalculation(sendData);
    if (response && response.success) {
      setCalculatedPrice(response.price);
    }
    //console.log(response);
  };

  const feetchUserData = async () => {
    await fetchToken();
    await fetchReferences();
    await fetchUserData();
  }

  useEffect(() => {
    if (isLoggedIn) {
      // fetchAddresses();
      fetchUserFavoriteClients();
    }
  }, [isLoggedIn]);


  useEffect(() => {
    feetchUserData();
  }, []);

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  // useEffect(() => {

  // }, [userFavoriteClients]);

  //if request made from another page and contact id is passed in url
  useEffect(() => {
    if (user) {// && defaultContact && defaultContact.isDefault
      handleAmIsideChange("1");
    }

    if (!searchParams || senderContacts.length <= 0) return;
    const contactId = searchParams.get("contactId");

    const foundClient = senderContacts.find((client) => {
      //console.log(client);
      return client.contacts?.some(
        (contact) => contact.id === parseInt(contactId)
      );
    });

    if (!foundClient) return;

    const foundContact = foundClient.contacts?.find(
      (contact) => contact.id === parseInt(contactId)
    );

    if (!foundContact || !foundClient) return;

    //setReceiver(prev => ({ ...prev, name: "tolma" }));
    handleOnReceiverValueChanged(foundClient, foundClient.name ?? "");
    handleRecieverContactValueChanged(foundContact, foundContact.name);
    //console.log("found Client", foundClient, foundContact);

  }, [user, defaultContact, searchParams, senderContacts]);

  //ამის დამთავრების მერე რომ ჩაიტვირთოს url ით 
  //გადმოცემული კონტაქტი ან აქ დავამატო ფლაგი რომ
  //არ გაასუფთავოს მეორე მხარე და ისე ჩატვირთოს
  useEffect(() => {
    // console.log("defaultContact changed", userFavoriteClients, defaultContact);
    if (user) {// && defaultContact && defaultContact.isDefault
      //handleAmIsideChange("1");
    }
  }, [user, defaultContact]);

  // useEffect(() => {
  //   if (searchParams && clients.length > 0) {
  //     const contactId = searchParams.get("contactId");
  //     const foundClient = clients.find((client) => {
  //       //console.log(client);
  //       return client.contacts?.some(
  //         (contact) => contact.id === parseInt(contactId)
  //       );
  //     });
  //     if (foundClient) {
  //       setSelectedClient(foundClient ? foundClient.label : "");
  //       handleClientChange(foundClient ? foundClient.label : "");

  //       // if (clientContacts.length > 0) {
  //       //   const foundContact = clientContacts.contacts?.find(
  //       //     (contact) => contact.id === parseInt(contactId)
  //       //   );
  //       //   if (foundContact) {
  //       //     setSelectedContact(foundContact.label);
  //       //     handleClientContactChange(foundContact.label);
  //       //   }
  //       // }
  //     }
  //   }
  // }, [searchParams, clients]);

  // useEffect(() => {
  //   if (searchParams && clientContacts.length > 0) {
  //     const contactId = searchParams.get("contactId");
  //     const selectedContact = clientContacts.find(
  //       (contact) => contact.id === parseInt(contactId)
  //     );
  //     if (selectedContact) {
  //       setSelectedContact(selectedContact.label);
  //       handleClientContactChange(selectedContact.label);
  //     }
  //   }
  // }, [searchParams, clientContacts]);

  // useEffect(() => {
  //   if (selectedId && addresses.length > 0) {
  //     //console.log([selectedId, addresses]);
  //     const extractedContacts = addresses.flatMap(
  //       (address) => address.contacts || []
  //     );
  //     const selectedContact = extractedContacts.find(
  //       (contact) => contact.id === parseInt(selectedId)
  //     );
  //     //console.log(selectedContact);
  //     if (selectedContact) {
  //       const address = addresses.find(
  //         (addr) => addr.id === selectedContact.addressId
  //       );
  //       if (address) {
  //         setReceiver({
  //           ...receiver,
  //           name: selectedContact.displayText,
  //           cityId: address.cityId,
  //           address: address.address,
  //           idNumber: selectedContact.personalId,
  //           contactPhone: selectedContact.contactPhone,
  //         });
  //         setSelectedCities({
  //           ...selectedCities,
  //           receiverCityName: address.cityName,
  //         });
  //         setSelectedContact(selectedContact.displayText);
  //       }
  //     }
  //   }
  // }, [selectedId, addresses]);


  // useEffect(() => {
  //   //console.log(addresses);
  //   if (addresses && addresses.length > 0) {
  //     const extractedContacts = addresses.flatMap(
  //       (address) => address.contacts || []
  //     );

  //     const updatedData = extractedContacts.map(
  //       ({ displayText, personalId, ...rest }) => ({
  //         ...rest,
  //         name: `${displayText} - ${personalId}`,
  //       })
  //     );
  //     //console.log(updatedData);
  //     setContacts(updatedData);
  //   }
  // }, [addresses]);



  useEffect(() => {
    if (pieces.length > 0) {
      calculateVolumeWeight();
    }
  }, [pieces]);

  useEffect(() => {
    if (cities.length != 0) {
      const updatedData = cities.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      setUpdatedCities(updatedData);
      //console.log(updatedData);
    }
  }, [cities]);

  useEffect(() => {
    if (deliveryOrderTypes.length != 0) {
      //console.log(deliveryOrderTypes);
      const updatedData = deliveryOrderTypes.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      //console.log(updatedData);
      setUpdatedDeliveryOrderTypes(updatedData);
      //console.log(updatedData);
    }
  }, [deliveryOrderTypes]);


  useEffect(() => {


    if (
      userFavoriteClients &&
      userFavoriteClients.clientAddress &&
      userFavoriteClients.clientAddress.length > 0
    ) {
      //console.log(userFavoriteClients);
      const extractedClients = userFavoriteClients
        .clientAddress
        .map(
          ({ ...rest }) => ({
            ...rest,
            userTypeName:
              rest.userTypeId === 1 ? "ფიზიკური პირი" : "იურიდიული პირი",
            label: `${rest.name} - ${rest.personalId}`,
            isDefault: rest.isDefault,
          })
        );
      //console.log(extractedClients);
      const nonDefaultClients = extractedClients.filter(client => !client.isDefault);
      setClients(nonDefaultClients);
      setSenderContacts(nonDefaultClients);

      const firstDefaultClient = extractedClients.find(client => client.isDefault);
      setDefaultContact(firstDefaultClient);
    }


  }, [userFavoriteClients]);





  useEffect(() => {
    if (activeStep === 2) {
      fetchPriceCalculation();
    }
  }, [activeStep]);

  // useEffect(() => {
  //   if (clients) console.log(clients);
  // }, [clients]);

  const handleNext = () => {
    //#region აქ ვრთავთ დროებით მოდალს რომ შევარემონტოთ
    // openDeliveryModal(11,"/10345635?exp=1778234878&sig=EEE5CE403DFE83FA88398739C7D4BF2C6698D5DA97E56897C3B9721328BC809C");
    //#endregion

    if (activeStep == 0) {
      const isValid1 = validateSender();
      const isValid2 = validateReceiver();

      if (isValid1 && isValid2) {
        setActiveStep((prevActiveStep) =>
          prevActiveStep + 1 === steps.length
            ? prevActiveStep
            : prevActiveStep + 1
        );
      }
    }
    if (activeStep == 1) {
      const validOrderInfo = validateOrderInfo();
      const validPieces = validatePieces();
      if (validOrderInfo && validPieces) {
        setActiveStep((prevActiveStep) =>
          prevActiveStep + 1 === steps.length
            ? prevActiveStep
            : prevActiveStep + 1
        );
      }
    }
    if (activeStep == 2) {
      //console.log(alertConfig);
      if (!captchaState.token) {
        //setAlertConfig({ ...alertConfig, show: false });
        setAlertConfig({
          ...alertConfig,
          icon: "warning",
          show: true,
          title: "აუცილებელია recaptcha",
        }); // Clear alert
      } else {
        setFormData({
          ...formData,
          recaptchaCode: captchaState.token,
          mobilePhone:
            iAmType === "1" ? sender.contactPhone : receiver.contactPhone,
        });

        const updatedSender = !sender.contactName
          ? { ...sender, contactName: sender.name }
          : sender;

        const updatedReceiver = !receiver.contactName
          ? { ...receiver, contactName: receiver.name }
          : receiver;

        // only update state if we actually changed something
        if (!sender.contactName) setSender(updatedSender);
        if (!receiver.contactName) setReceiver(updatedReceiver);

        // if (!sender.contactName)
        //   setSender({ ...sender, contactName: sender.name });
        // if (!receiver.contactName)
        //   setReceiver({ ...receiver, contactName: receiver.name });

        if (!isLoggedIn) {
          sendSms({
            mobilePhone:
              iAmType === "1" ? sender.contactPhone : receiver.contactPhone,
            recaptchaCode: captchaState.token,
          });
          openCreateEventModal(true);
        } else {
          fetchAddDeliveryOrder(updatedSender, updatedReceiver);
        }

        setResetCaptcha(!resetCaptcha);
      }
      // setAlertConfig({
      //   show: true,
      //   title: "გაფრთხილება",
      //   text: "გსურთ ფაქტურის შექმნა?",
      //   icon: "warning",
      // }); // Clear alert
      //handleGeneratePdf();
    }
    //setSkipped(newSkipped);
    console.log([receiver, sender, orderInfo]);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const calculateVolumeWeight = () => {
    const volumeWeight = pieces.reduce((acc, piece) => {
      const length = parseFloat(piece.length) || 0;
      const width = parseFloat(piece.width) || 0;
      const height = parseFloat(piece.height) || 0;
      return acc + (length * width * height) / 6000;
    }, 0);
    const w = parseFloat(volumeWeight).toFixed(5) || 0;
    setOrderInfo({ ...orderInfo, volumeWeight: w });
  };

  const handleOptionChange = (event, type) => {
    const value =
      typeof event === "string" || typeof event === "number"
        ? event.toString()
        : event.target.value;

    handleAmIsideChange(value, type);
  }


  const handleAmIsideChange = (value, type) => {


    //setFormData({ ...formData, userTypeId: value });
    if (type === "sender") {
      // console.log(["here",value]);
      setSelectedOptionSender(value);

      setSender(prev => ({ ...prev, clientTypeId: value }));
    } else if (type === "receiver") {
      setSelectedOptionReceiver(value);
      //setReceiver({ ...receiver, clientTypeId: value });
      setReceiver(prev => ({
        ...prev,
        clientTypeId: value
      }));

    } else {
      setIAmType(value);
      setOrderInfo({ ...orderInfo, payerSideId: value });
    }

    //if user logged in when seleceting i'm sender or reciever user login info feels forms autmaticly

    if (user && !type) {

      //თუ კონტაქტი არ მოიძებნა იუზერით ჩვანაცვლოთ
      const defConcat = {
        name: user.fullName,
        idNumber: user.personalId,
        contactName: "",
        clientTypeId: isLoggedIn ? user.userTypeId.toString() : "1",
        contactName: user.userTypeId === "1" ? user.fullName : "",
        contactPhone: user.mobile,
        cityId: null,
        cityName: "",
        address: ""
      };

      if (defaultContact.name) {
        defConcat.name = defaultContact.name;
        defConcat.idNumber = defaultContact.personalId;

        //we have to get 
        let defUfContact = defaultContact.contacts?.find(c => c.isDefault);
        if (defUfContact) {

          defConcat.contactName = defUfContact.name;
          defConcat.cityId = defUfContact.cityId;
          defConcat.cityName = defUfContact.cityName;
          defConcat.address = defUfContact.address;
          defConcat.contactPhone = defUfContact.contactPhone;
        }
      }

      //მიმღები
      if (value === "2") {

        //clean up other side
        setSender(prev => (
          {
            ...prev,
            name: "",
            idNumber: "",
            contactPhone: "",
            clientTypeId: 1,
            cityId: null,
            address: "",
            contactName: "",
          }));
        setSelectedCities(prev => ({
          ...prev,
          senderCityName: "",
        }));



        if (defaultContact) {
          // console.log("defaultContact", defaultContact);
          setSelectedReceiverClient(defaultContact);

          if (defaultContact.contacts?.length > 0) {
            filterAndMapRecieverContacts(defaultContact, null);
          }
        }


        setReceiver(prev => ({
          ...prev,
          name: defConcat.name,
          idNumber: defConcat.idNumber,
          contactPhone: defConcat.contactPhone,
          clientTypeId: defConcat.clientTypeId,
          cityId: defConcat.cityId,
          address: defConcat.address,
          contactName: defConcat.contactName,
        }));


        if (defConcat.cityName) {
          //აქ სწორი city name თუ სითი ნაპოვნია
          setSelectedCities(prev => ({
            ...prev,
            receiverCityName: defConcat.cityName,
          }));
        }


        // setReceiver(prev => ({
        //   ...prev,
        //   name: user.fullName,
        //   idNumber: user.personalId,
        //   contactPhone: user.mobile,
        //   clientTypeId: isLoggedIn && user ? user.userTypeId.toString() : "1",
        // }));

        if (isLoggedIn && user) {
          // setReceiver({
          //   ...receiver,
          //   clientTypeId: user.userTypeId.toString(),
          // });
          setSelectedOptionReceiver(user.userTypeId.toString());
        }

        setSelectedClient("");
        setSelectedContact("");
        setSelectedSenderClient("");
        setSelectedSenderContact("");
      }


      if (value === "1") {


        //clean up other side
        setReceiver(prev => (
          {
            ...prev,
            name: "",
            idNumber: "",
            contactPhone: "",
            clientTypeId: 1,
            cityId: null,
            address: "",
            contactName: "",
          }));
        setSelectedCities(prev => ({
          ...prev,
          receiverCityName: "",
        }));

        if (defaultContact) {
          setSelectedSenderClient(defaultContact);
          if (defaultContact.contacts?.length > 0) {
            filterAndMapSenderContacts(defaultContact, null);
          }
        }


        //set new values
        setSender(prev => ({
          ...prev,
          name: defConcat.name,
          idNumber: defConcat.idNumber,
          contactPhone: defConcat.contactPhone,
          clientTypeId: defConcat.clientTypeId,
          cityId: defConcat.cityId,
          address: defConcat.address,
          contactName: defConcat.contactName,
        }));

        if (defConcat.cityName) {
          //აქ სწორი city name თუ სითი ნაპოვნია
          setSelectedCities(prev => ({
            ...prev,
            senderCityName: defConcat.cityName,
          }));
        }


        if (isLoggedIn && user) {
          // setSender({
          //   ...sender,
          //   clientTypeId: user.userTypeId.toString(),
          // });
          setSelectedOptionSender(user.userTypeId.toString());
        }
        setSelectedClient("");
        setSelectedContact("");
        setSelectedReceiverClient("");
        setSelectedReceiverContact("");
      }

      if (value === "3") {

        setSender(prev => (
          {
            ...prev,
            name: "",
            idNumber: "",
            contactPhone: "",
            clientTypeId: 1,
            cityId: null,
            address: "",
            contactName: "",
          }));

        setReceiver(prev => (
          {
            ...prev,
            name: "",
            idNumber: "",
            contactPhone: "",
            clientTypeId: 1,
            cityId: null,
            address: "",
            contactName: "",
          }));

        setSelectedCities(prev => ({
          ...prev,
          receiverCityName: "",
          senderCityName: "",
        }));

        setSelectedOptionReceiver("1");
        setSelectedOptionSender("1");
        // if (user) {
        //   //
        //   setSender(prev => ({ ...prev, name: "", idNumber: "", contactPhone: "" }));
        //   setReceiver(prev => ({ ...prev, name: "", idNumber: "", contactPhone: "" }));
        // }
        setSelectedClient("");
        setSelectedContact("");
      }
    }

  };



  const handlePieceInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...pieces];
    list[index][name] = value;
    const length = parseFloat(list[index].length) || 0;
    const width = parseFloat(list[index].width) || 0;
    const height = parseFloat(list[index].height) || 0;
    list[index].pieceVolume = parseFloat(
      (length * width * height) / 6000
    ).toFixed(5);
    setPieces(list);
  };

  const handlDeliveryChange = (selectedOption) => {
    const selectedValue = selectedOption.target.value;
    setSelectedDeliveryOrderType(selectedValue);

    const deliveryOrderType = updatedDeliveryOrderTypes.find(
      (c) => c.name === selectedOption.target.value
    );
    //console.log(deliveryOrderType);
    if (deliveryOrderType) {
      setOrderInfo({ ...orderInfo, deliveryOrderTypeId: deliveryOrderType.id });
    }
    //console.log("Selected Option:", selectedValue);
  };

  const handleOrderInfoChange = (e) => {
    const { name, value } = e.target;
    if (name === "pieceQuantity") {
      const intValue = parseInt(value, 10);
      if (!isNaN(intValue)) {
        const newPieces = Array.from({ length: intValue }, (_, i) => ({
          pieceNumber: i + 1,
          length: "",
          width: "",
          height: "",
        }));
        setPieces(newPieces);
        setOrderInfo({ ...orderInfo, [name]: intValue });
      } else {
        setPieces([]);
      }
    }
    setOrderInfo({ ...orderInfo, [name]: value });
  };

  const handleSenderChange = (e) => {
    let { name, value } = e.target;
    if (name === "contactPhone") {
      value = value.replace(/[^0-9]/g, "");
    }
    setSender({ ...sender, [name]: value });
  };

  const handleReceiverChange = (e) => {
    let { name, value } = e.target;
    if (name === "contactPhone") {
      value = value.replace(/[^0-9]/g, "");
    }
    setReceiver({ ...receiver, [name]: value });
  };

  const validateSender = () => {

    let errors = {};
    if (!sender.name) {
      errors.name = "სახელი აუცილებელია";
    }
    if (!sender.idNumber) {
      errors.idNumber = "პირადი ნომერი აუცილებელია";
    }
    if (!sender.address) {
      errors.address = "მისამართი აუცილებელია";
    }

    const phone = sender.contactPhone.replace(/[^0-9]/g, "");
    if (!phone.trim()) {
      errors.contactPhone = "ნომერი აუცილებელია";
    } else if (phone.trim().length !== 9) {
      errors.contactPhone = "არასწორი ნომერი";
    }

    // console.log(sender.cityId);
    // console.log(selectedCities);
    // console.log([sender, receiver]);
    if (!sender.cityId) {
      errors.cityId = "ქალაქი აუცილებელია";
    }

    if (sender.clientTypeId === "2" && !sender.contactName) {
      errors.contactName = "საკონტაქტო პირი აუცილებელია";
    }

    setSenderErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const validateReceiver = () => {
    let errors = {};
    if (!receiver.name) {
      if (!isLoggedIn) {
        errors.name = "აირჩიეთ კლიენტი და საკოტაქტო პირი";
      } else {
        errors.name = "სახელი აუცილებელია";
      }
    }
    if (!receiver.idNumber) {
      errors.idNumber = "პირადი ნომერი აუცილებელია";
    }
    if (!receiver.address) {
      errors.address = "მისამართი აუცილებელია";
    }

    const phone = receiver.contactPhone.replace(/[^0-9]/g, "");
    //console.log([receiver.contactPhone, phone]);
    if (!phone.trim()) {
      errors.contactPhone = "ნომერი აუცილებელია";
    } else if (phone.trim().length !== 9) {
      errors.contactPhone = "არასწორი ნომერი";
    }

    if (!receiver.cityId) {
      errors.cityId = "ქალაქი აუცილებელია";
    }

    if (receiver.clientTypeId === "2" && !receiver.contactName) {
      errors.contactName = "საკონტაქტო პირი აუცილებელია";
    }

    setReceiverErrors(errors);
    // console.log(errors);
    return Object.keys(errors).length === 0;
  };

  const validateOrderInfo = () => {
    let errors = {};
    if (!orderInfo.pieceQuantity) {
      errors.pieceQuantity = "რაოდენობა აუცილებელია";
    }
    if (!orderInfo.weight) {
      errors.weight = "წონა აუცილებელია";
    }
    if (!orderInfo.deliveryMethodId) {
      errors.deliveryMethodId = "მიწოდების მეთოდი აუცილებელია";
    }
    //console.log(orderInfo.deliveryOrderTypeId);
    if (!orderInfo.deliveryOrderTypeId || orderInfo.deliveryOrderTypeId == "") {
      errors.deliveryOrderTypeId = "სერვისი აუცილებელია";
    }
    if (!orderInfo.paymentMethodId) {
      errors.paymentMethodId = "გადახდის მეთოდი აუცილებელია";
    }
    if (!orderInfo.insuranceItemPrice) {
      errors.insuranceItemPrice = "გზავნილის შეფასება აუცილებელია";
    }
    if (!orderInfo.comment || orderInfo.comment.length < 4) {
      errors.comment = "კომენტარი უნდა იყოს მინიმუმ 4 სიმბოლო";
    }

    //console.log(errors);

    setOrderInfoErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validatePieces = () => {
    let errors = {};
    if (orderInfo.packageTypeId == 2) {
      pieces.forEach((piece, index) => {
        if (!piece.length) {
          errors[`length-${index}`] = "სიგრძე აუცილებელია";
        }
        if (!piece.width) {
          errors[`width-${index}`] = "სიგანე აუცილებელია";
        }
        if (!piece.height) {
          errors[`height-${index}`] = "სიმაღლე აუცილებელია";
        }
      });

      setPieceErrors(errors);
    }
    return Object.keys(errors).length === 0;
  };

  const handleValueFromChild = (value) => {
    setValueFromChild(value); // Update parent's state with the value
  };

  const handleValueFromChildContact = (value) => {
    setValueFromChildContact(value); // Update parent's state with the value
  };

  const handleSenderValue = (value) => {
    setValSender(value);
  };

  const handleSenderContactValue = (value) => {
    setValSenderContact(value);
  };

  const handleContactChange = (selectedOption) => {
    if (!selectedOption) {
      setReceiver({ ...receiver, name: valueFromChild });
    } else {
      const [firstValue, secondValue] = selectedOption
        .split("-")
        .map((val) => val.trim());
      //console.log(firstValue, secondValue);
      const contact = updatedContacts.find(
        (contact) => contact.name === selectedOption
      );
      if (contact) {
        //console.log(contact);
        const address = addresses.find((addr) => addr.id === contact.addressId);
        if (address) {
          setReceiver({
            ...receiver,
            name: firstValue,
            cityId: address.cityId,
            address: address.address,
            idNumber: secondValue,
            contactPhone: contact.contactPhone,
          });
          setSelectedCities({
            ...selectedCities,
            receiverCityName: address.cityName,
          });
        }
        //setReceiver({ ...receiver, idNumber: contact.id });
      }
      setSelectedContact(selectedOption);
    }
    console.log(receiver);
  };

  //#region გამგზავნი -sender

  //გამგზავნის ამორჩევა კონტაქტებიდან
  const handleOnSenderValueChanged = (selecteditem, text) => {

    //if we got only text set text and return
    setSender(prev => ({ ...prev, name: text }));
    if (!selecteditem) return;

    const client = selecteditem;

    setSelectedSenderClient(client);
    //set recievers usertype
    handleOptionChange(client.userTypeId, "sender");

    //set personal id
    setSender(prev => ({
      ...prev,
      name: client.name,
      idNumber: client.personalId  // sets correct value
    }));
    //console.log(client);
    filterAndMapSenderContacts(client, null);

  }

  const cookContactLabel = (rest) => {
    return `${rest.cityName},${rest.address} - ${rest.name}`
  }

  const filterAndMapSenderContacts = (client, cityId) => {
    const choosenCityId = cityId || sender.cityId;

    if (!client.contacts) return;

    const clientContacts = client.contacts
      .filter((contact) => !choosenCityId || contact.cityId === choosenCityId)
      .map(({ ...rest }) => ({
        ...rest,
        label: cookContactLabel(rest),//`${rest.cityName} - ${rest.address} - ${rest.name}`,
      }));

    setSenderClientContacts(clientContacts);

    if (clientContacts.length === 1) {
      handleSenderContactValueChanged(clientContacts[0], clientContacts[0].name);
    }
  }

  const handleSenderCityValueChanged = (selecteditem, text) => {

    if (!selecteditem) {
      setSender(prev => ({ ...prev, cityId: undefined }));
      return;
    };

    const city = selecteditem;
    setSender(prev => ({ ...prev, cityId: city.id }));
    setSelectedCities(prev => ({ ...prev, senderCityName: city.name }));

    if (!selectedSenderClient) return;
    filterAndMapSenderContacts(selectedSenderClient, city.id);
  }

  //მიმღების კონტაქტი ამოირჩია ან ჩაწერა
  const handleSenderContactValueChanged = (selecteditem, text) => {


    // console.log([selecteditem, text]);
    setSender(prev => ({ ...prev, contactName: text }));

    if (!selecteditem) return;
    //წინა მნიშვნელობის შესანახად ქონდა მგონი საერთოდ არ ჭირდება
    // setSelectedContact(text);
    // setselectedSenderContact(text);

    // console.log(selecteditem);

    const contact = selecteditem;
    //set other data too
    setSender(prev => ({
      ...prev,
      contactPhone: contact.contactPhone,
      //name: contact.name,
      cityId: contact.cityId,
      address: contact.address,
      // contactName: contact.name
    }));
    // You can add logic here to handle the selected contact
    setSelectedCities(prev => ({
      ...prev,
      senderCityName: contact.cityName,
    }));

  }
  //#endregion  


  //#region მიმღები -Receiver


  //მიმღების ამორჩევა კონტაქტებიდან
  const handleOnReceiverValueChanged = (selecteditem, text) => {

    //if we got only text set text and return
    setReceiver(prev => ({ ...prev, name: text }));
    if (!selecteditem) return;

    const client = selecteditem;

    setSelectedReceiverClient(client);
    //set reciever's usertype
    handleOptionChange(client.userTypeId, "receiver");

    //set personal id
    setReceiver(prev => ({
      ...prev,
      name: client.name,
      idNumber: client.personalId  // sets correct value
    }));
    console.log("handleOnReceiverValueChanged", client, receiver);

    filterAndMapRecieverContacts(client, null);

  }

  const filterAndMapRecieverContacts = (client, cityId) => {
    const choosenCityId = cityId || receiver.cityId;

    if (!client.contacts) return;

    const clientContacts = client.contacts
      .filter((contact) => !choosenCityId || contact.cityId === choosenCityId)
      .map(({ ...rest }) => ({
        ...rest,
        label: cookContactLabel(rest),//`${rest.cityName} - ${rest.name} - ${rest.contactPhone}`,
      }));



    setClientContacts(clientContacts);

    if (clientContacts.length === 1) {
      handleRecieverContactValueChanged(clientContacts[0], clientContacts[0].name);
    }
  }

  const handleRecieverCityValueChanged = (selecteditem, text) => {

    if (!selecteditem) {
      setReceiver(prev => ({ ...prev, cityId: undefined }));
      return;
    };
    const city = selecteditem;
    setReceiver(prev => ({ ...prev, cityId: city.id }));
    setSelectedCities(prev => ({ ...prev, receiverCityName: city.name }));

    if (!selectedReceiverClient) return;
    filterAndMapRecieverContacts(selectedReceiverClient, city.id);
  }

  const handleSelectChange = (val, type) => {
    //console.log([val, type]);
    const city = updatedCities.find((city) => city.name === val);
    //console.log(city);
    if (city) {
      if (type === "sender") {
        setSender({ ...sender, cityId: city.id });
        setSelectedCities({ ...selectedCities, senderCityName: city.name });
      } else {
        setReceiver({ ...receiver, cityId: city.id });
        setSelectedCities({ ...selectedCities, receiverCityName: city.name });
      }
    }
  };


  //მიმღების კონტაქტი ამოირჩია ან ჩაწერა
  const handleRecieverContactValueChanged = (selecteditem, text) => {


    setReceiver(prev => ({ ...prev, contactName: text }));

    if (!selecteditem) return;
    //წინა მნიშვნელობის შესანახად ქონდა მგონი საერთოდ არ ჭირდება
    setSelectedContact(text);


    const contact = selecteditem;
    //set other data too
    setReceiver(prev => ({
      ...prev,
      contactPhone: contact.contactPhone,
      //name: contact.name,
      cityId: contact.cityId,
      address: contact.address,
      // contactName: contact.name
    }));
    // You can add logic here to handle the selected contact
    setSelectedCities(prev => ({
      ...prev,
      receiverCityName: contact.cityName,
    }));

  }
  //#endregion  

  const handleClientContactChange = (selectedOption) => {
    //console.log(selectedOption);

    setReceiver({ ...receiver, contactName: valueFromChildContact });

    if (!selectedOption) return;
    setSelectedContact(selectedOption);

    // const [firstValue, secondValue] = selectedOption
    //   .split("-")
    //   .map((val) => val.trim());

    var contact = clientContacts.find(
      (contact) => contact.label === selectedOption
    );

    if (contact) {
      //alert(1);
      setReceiver({
        ...receiver,
        contactPhone: contact.contactPhone,
        name: contact.name,
        cityId: contact.cityId,
        address: contact.address,
        contactName: contact.name,
      });
      // You can add logic here to handle the selected contact
      setSelectedCities({
        ...selectedCities,
        receiverCityName: contact.cityName,
      });
    } else {
      //console.log(selectedOption);
      setReceiver({
        ...receiver,
        name: valueFromChildContact,
      });
    }
  };

  const handleClientChange = (selectedOption) => {

    console.log(selectedOption);
    //setReceiver({ ...sender, name: valueFromChild });
    setReceiver(prev => ({ ...prev, name: selectedOption }));
    if (!selectedOption) return;
    // console.log(selectedOption);

    setSelectedClient(selectedOption);
    const client = clients.find((client) => client.label === selectedOption);

    if (!client) {
      return;
    }
    console.log(client);

    const clientContacts = client.contacts.map(({ ...rest }) => ({
      ...rest,
      label: `${rest.cityName} - ${rest.name} - ${rest.contactPhone}`,
    }));

    handleOptionChange(client.userTypeId, "receiver");

    setReceiver(prev => ({
      ...prev,
      idNumber: client.personalId  // sets correct value
    }));
    // setReceiver({
    //   ...receiver,
    //   idNumber: client.personalId,
    // });
    client ? setClientContacts(clientContacts) : setClientContacts([]);
  };

  const handleClientSenderChange = (selectedOption) => {
    //console.log(selectedOption);
    setSender(prev => ({ ...prev, name: valSender }));
    if (!selectedOption) return;

    setSelectedSenderClient(selectedOption);
    const client = clients.find((client) => client.label === selectedOption);
    //console.log(client.personalId);
    const clientContacts = client.contacts.map(({ ...rest }) => ({
      ...rest,
      label: `${rest.cityName} - ${rest.name} - ${rest.contactPhone}`,
    }));

    handleOptionChange(client.userTypeId, "sender");

    setSender(prev => ({
      ...prev,
      idNumber: client.personalId,
    }));
    client
      ? setSenderClientContacts(clientContacts)
      : setSenderClientContacts([]);
  };



  const handleSenderClientContactChange = (selectedOption) => {
    setSender({ ...sender, contactName: valueFromChildContact });

    if (!selectedOption) return;
    setSelectedSenderContact(selectedOption);

    // const [firstValue, secondValue] = selectedOption
    //   .split("-")
    //   .map((val) => val.trim());

    var contact = senderClientContacts.find(
      (contact) => contact.label === selectedOption
    );
    //console.log(contact);
    if (contact) {
      //alert(1);
      setSender({
        ...sender,
        contactPhone: contact.contactPhone,
        name: contact.name,
        cityId: contact.cityId,
        address: contact.address,
        contactName: contact.name,
      });
      // You can add logic here to handle the selected contact
      setSelectedCities({
        ...selectedCities,
        senderCityName: contact.cityName,
      });
    } else {
      //console.log(selectedOption);
      setSender({
        ...sender,
        name: valueFromChildContact,
      });
    }
  };

  const openCreateEventModal = (bool) => {
    setCreateEventModal(bool ?? !createEventModal);
    //console.log(createEventModal);
  };

  const senderConcatcFieldIsvisible = () => {
    if (isLoggedIn) {
      //თუ შესულია და კონტაქტები არ ყავს და ფიზიკური პირია მაშინ გამოვაჩინოთ
      //თუ გამგზავნია, ფიზიკური პირია და დეფაულტის კონტაქტები არ ყავს დავმალოთ
      //
      switch (iAmType) {
        case "1":
          return !(sender.clientTypeId == "1" && senderClientContacts.length <= 0)
          break;
        case "2":
          return !(sender.clientTypeId == "1" && clients.length <= 0);
          break;
      }

    }
    else {
      //თუ შესული არ არის და ფიზიკური პირია მაშინ კონტაქტი უდრის კლიენტს
      return sender.clientTypeId === "2";
    }
    return true;
  }

  const recieverConcatcFieldIsvisible = () => {

    if (isLoggedIn) {

      switch (iAmType) {
        case "2":
          return !(receiver.clientTypeId == "1" && clientContacts.length <= 0)
          break;
        case "1":
          return !(receiver.clientTypeId == "1" && clients.length <= 0);
          break;
      }

      //თუ შესულია და კონტაქტები არ ყავს და ფიზიკური პირია მაშინ გამოვაჩინოთ
      //თუ გამგზავნია, ფიზიკური პირია და კონტაქტები არ ყავს დავმალოთ
    }
    else {
      //თუ შესული არ არის და ფიზიკური პირია მაშინ კონტაქტი უდრის კლიენტს
      return receiver.clientTypeId === "2";
    }
    return true;
  }


  const TabRenderer = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <div className="mb-4 flex mt-10">
              <label className="text-gray-700 text-lg font-bold mb-2 mr-2">
                მე ვარ:
              </label>
              <div className="flex items-center text-lg">
                <input
                  type="radio"
                  id="sender"
                  name="role"
                  value="1"
                  className="mr-2"
                  checked={iAmType === "1"}
                  onChange={(e) => handleOptionChange(e)}
                />
                <label htmlFor="sender" className="mr-4">
                  გამგზავნი
                </label>
                <input
                  type="radio"
                  id="receiver"
                  name="role"
                  value="2"
                  className="mr-2"
                  checked={iAmType === "2"}
                  onChange={(e) => handleOptionChange(e)}
                />
                <label htmlFor="receiver" className="mr-4">
                  მიმღები
                </label>
                {isLoggedIn && (
                  <>
                    <input
                      type="radio"
                      id="payer"
                      name="role"
                      value="3"
                      className="mr-2"
                      checked={iAmType === "3"}
                      onChange={(e) => handleOptionChange(e)}
                    />
                    <label htmlFor="payer">გადამხდელი</label>
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4">
              <div className="p-4 border rounded shadow md:w-[calc(50%-0.5rem)]">
                <h3 className="text-lg font-bold mb-2">გამგზავნი</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                  }}
                >
                  <div className="form-control mb-5 ">
                    <div className="parent-container">
                      <input
                        type="radio"
                        name="senderOptions"
                        id="senderPhysical"
                        value="1"
                        checked={selectedOptionSender === "1"}
                        onChange={(e) => handleOptionChange(e, "sender")}
                        className="form-radio radio-button"
                        disabled={
                          isLoggedIn &&
                          user &&
                          user.userTypeId.toString() === "2" &&
                          iAmType === "1"
                        }
                      />
                      <label className="form-label" htmlFor="senderPhysical">
                        ფიზიკური პირი
                      </label>
                    </div>
                  </div>
                  <div className="form-control mb-5 ml-5">
                    <div className="parent-container">
                      <input
                        type="radio"
                        name="senderOptions"
                        id="senderLegal"
                        value="2"
                        checked={selectedOptionSender === "2"}
                        onChange={(e) => handleOptionChange(e, "sender")}
                        className="form-radio radio-button"
                        disabled={
                          isLoggedIn &&
                          user &&
                          user.userTypeId.toString() === "1" &&
                          iAmType === "1"
                        }
                      />
                      <label className="form-label" htmlFor="senderLegal">
                        იურიდიული პირი
                      </label>
                    </div>
                  </div>
                </div>

                <div className="space-y-4 mx-auto">
                  <div className="flex space-x-4">
                    <div className="w-full">
                      <div className="form-control mb-5">
                        <label htmlFor="senderName" className="form-label ">
                          {sender.clientTypeId === "1"
                            ? "სახელი და გვარი"
                            : "გამგზავნის დასახელება"}
                        </label>
                        <CustomCombobox
                          options={iAmType === "2" ? clients : []}
                          label="label"
                          textField="name"
                          defaultText={sender.name}
                          id="senderName"
                          // selectedValue={selectedSenderClient}
                          onValueChanged={handleOnSenderValueChanged}
                        />
                        {senderErrors.name && (
                          <div className="text-danger text-[12px]/[16px]">
                            {senderErrors.name}
                          </div>
                        )}
                        <label htmlFor="senderCityId" className="form-label">
                          ქალაქი
                        </label>
                        <CustomCombobox
                          options={updatedCities}
                          label="name"
                          textField="name"
                          id="senderCityId"
                          onValueChanged={handleSenderCityValueChanged}
                          defaultText={selectedCities.senderCityName}
                          allowClear={true}
                          comboBoxOnly={true}
                        />
                        {senderErrors.cityId && (
                          <div className="text-danger text-[12px]/[16px]">
                            {senderErrors.cityId}
                          </div>
                        )}
                        {senderConcatcFieldIsvisible() &&
                          (
                            <>
                              <label className="form-label" htmlFor="senderContactName">
                                საკონტაქტო პირი
                              </label>
                              <CustomCombobox
                                // options={iAmType === "2" ? senderClientContacts : [defaultContact.contacts]}//სხვა ჯიშის კონტაქტები გამოუჩნდება თუ დალოგინებულაი და თავისი კონტაქები შევსებულია აქვს
                                options={senderClientContacts}
                                label="label"
                                textField="name"
                                id="senderContactName"
                                onValueChanged={handleSenderContactValueChanged}
                                defaultText={sender.contactName}
                              />
                              {senderErrors.contactName && (
                                <div className="text-danger text-[12px]/[16px]">
                                  {senderErrors.contactName}
                                </div>
                              )}
                            </>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4 mx-auto">
                  <div className="flex space-x-4">
                    <div className="w-1/2">
                      <div className="form-control mb-5">
                        <label htmlFor="senderIdNumber" className="form-label ">
                          {sender.clientTypeId === "1"
                            ? "პირადი ნომერი"
                            : "საიდენტიფიკაციო კოდი"}
                        </label>
                        <input
                          id="senderIdNumber"
                          placeholder="00000000000"
                          className="form-input"
                          value={sender.idNumber}
                          name="idNumber"
                          onChange={(e) => handleSenderChange(e)}
                        />
                        {senderErrors.idNumber && (
                          <div className="text-danger text-[12px]/[16px]">
                            {senderErrors.idNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-1/2">
                      <div className="form-control">
                        <label
                          htmlFor="senderContactPhone"
                          className="form-label"
                        >
                          ტელეფონი
                        </label>
                        <MaskedInput
                          mask={[
                            "(",
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          id="senderContactPhone"
                          className="form-input"
                          required
                          value={sender.contactPhone}
                          type="text"
                          placeholder="(555) 555-555"
                          name="contactPhone"
                          onChange={handleSenderChange}
                          autoComplete="off"
                        ></MaskedInput>
                        {senderErrors.contactPhone && (
                          <div className="text-danger text-[12px]/[16px]">
                            {senderErrors.contactPhone}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4 mx-auto">
                  <div className="form-control mb-5">
                    <label htmlFor="senderAddress" className="form-label ">
                      მისამართი
                    </label>
                    <input
                      id="senderAddress"
                      placeholder="მისამართი"
                      className="form-input"
                      name="address"
                      value={sender.address}
                      onChange={(e) => handleSenderChange(e)}
                    />
                    {senderErrors.address && (
                      <div className="text-danger text-[12px]/[16px]">
                        {senderErrors.address}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="p-4 border rounded shadow md:w-[calc(50%-0.5rem)]">
                <h3 className="text-lg font-bold mb-2">მიმღები</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                  }}
                >
                  <div className="form-control mb-5">
                    <div className="parent-container">
                      <input
                        type="radio"
                        name="receiverOptions"
                        value="1"
                        id="receiverPhysical"
                        checked={selectedOptionReceiver === "1"}
                        onChange={(e) => handleOptionChange(e, "receiver")}
                        className="form-radio radio-button"
                        disabled={
                          isLoggedIn &&
                          user &&
                          user.userTypeId.toString() === "2" &&
                          iAmType === "2"
                        }
                      />
                      <label className="form-label" htmlFor="receiverPhysical">
                        ფიზიკური პირი
                      </label>
                    </div>
                  </div>
                  <div className="form-control mb-5 ml-5">
                    <div className="parent-container">
                      <input
                        type="radio"
                        name="receiverOptions"
                        value="2"
                        id="receiverLegal"
                        checked={selectedOptionReceiver === "2"}
                        onChange={(e) => handleOptionChange(e, "receiver")}
                        className="form-radio radio-button"
                        disabled={
                          isLoggedIn &&
                          user &&
                          user.userTypeId.toString() === "1" &&
                          iAmType === "2"
                        }
                      />
                      <label className="form-label" htmlFor="receiverLegal">
                        იურიდიული პირი
                      </label>
                    </div>
                  </div>
                </div>

                <div className="space-y-4 mx-auto">
                  <div className="flex space-x-4">
                    <div className="w-full">
                      <div className="form-control mb-5">
                        <label htmlFor="receiverName" className="form-label">
                          {receiver.clientTypeId === "1"
                            ? "სახელი და გვარი"
                            : "მიმღების დასახელება"}
                        </label>
                        <CustomCombobox
                          options={iAmType === "1" ? clients : []}
                          label="label"
                          textField="name"
                          id="comboReceiverName"
                          isSearchable={true}
                          onValueChanged={handleOnReceiverValueChanged}
                          defaultText={receiver.name}
                        />
                        {receiverErrors.name && (
                          <div className="text-danger text-[12px]/[16px]">
                            {receiverErrors.name}
                          </div>
                        )}
                        <label htmlFor="receiverCityId" className="form-label">
                          ქალაქი
                        </label>
                        <CustomCombobox
                          options={updatedCities}
                          label="name"
                          textField="name"
                          id="receiverCityId"
                          isSearchable={true}
                          onValueChanged={handleRecieverCityValueChanged}
                          defaultText={selectedCities.receiverCityName}
                          allowClear={true}
                          comboBoxOnly={true}
                        />
                        {receiverErrors.cityId && (
                          <div className="text-danger text-[12px]/[16px]">
                            {receiverErrors.cityId}
                          </div>
                        )}
                        {recieverConcatcFieldIsvisible() && (
                          <>
                            <label className="form-label">
                              საკონტაქტო პირი
                            </label>
                            <CustomCombobox
                              options={clientContacts}
                              label="label"
                              textField="name"
                              id="comboReceiverContactName"
                              isSearchable={true}
                              onValueChanged={handleRecieverContactValueChanged}
                              defaultText={receiver.contactName}
                            />
                            {receiverErrors.contactName && (
                              <div className="text-danger text-[12px]/[16px]">
                                {receiverErrors.contactName}
                              </div>
                            )}
                          </>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4 mx-auto">
                  <div className="flex space-x-4">
                    <div className="w-1/2">
                      <div className="form-control mb-5">
                        <label
                          htmlFor="receiverIdNumber"
                          className="form-label "
                        >
                          {receiver.clientTypeId === "1"
                            ? "პირადი ნომერი"
                            : "საიდენტიფიკაციო კოდი"}
                        </label>
                        <input
                          id="receiverIdNumber"
                          placeholder="00000000000"
                          value={receiver.idNumber}
                          className="form-input"
                          id="receiverIdNumber"
                          name="idNumber"
                          onChange={(e) => handleReceiverChange(e)}
                        />
                        {receiverErrors.idNumber && (
                          <div className="text-danger text-[12px]/[16px]">
                            {receiverErrors.idNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-1/2">
                      <div className="form-control mb-5">
                        <label
                          htmlFor="receiverContactPhone"
                          className="form-label"
                        >
                          ტელეფონი
                        </label>
                        <MaskedInput
                          mask={[
                            "(",
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          id="receiverContactPhone"
                          className="form-input"
                          required
                          value={receiver.contactPhone}
                          type="text"
                          placeholder="(555) 555-555"
                          name="contactPhone"
                          onChange={handleReceiverChange}
                          autoComplete="off"
                        ></MaskedInput>
                        {receiverErrors.contactPhone && (
                          <div className="text-danger text-[12px]/[16px]">
                            {receiverErrors.contactPhone}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4 mx-auto">
                  <div className="form-control mb-5">
                    <label htmlFor="receiverAddress" className="form-label ">
                      მისამართი
                    </label>
                    <input
                      id="receiverAddress"
                      placeholder="მისამართი"
                      className="form-input"
                      name="address"
                      value={receiver.address}
                      onChange={(e) => handleReceiverChange(e)}
                    />
                    {receiverErrors.address && (
                      <div className="text-danger text-[12px]/[16px]">
                        {receiverErrors.address}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <div className="h-[8px]">&nbsp;</div>
            <div className="flex flex-wrap">
              <div className="w-full">
                <div className="flex space-x-4">
                  <div className="form-control mb-5 w-3/12">
                    <label htmlFor="orderInfoErrors" className="form-label">
                      აირჩიეთ სერვისი
                    </label>
                    <div className="w-full">
                      <select
                        onChange={handlDeliveryChange}
                        value={selectedDeliveryOrderType}
                        className="w-full form-select cursor-pointer rounded-e-md bg-card-color py-[6px] pe-30 text-[14px]/[32px] appearance-none border border-border-color focus:outline-0 focus:border-primary"
                      >
                        <option value="" disabled defaultValue="">
                          აირჩიეთ
                        </option>
                        {updatedDeliveryOrderTypes.map((type) => (
                          <option key={type.id} value={type.name}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {orderInfoErrors.deliveryOrderTypeId && (
                      <div className="text-danger text-[12px]/[16px]">
                        {orderInfoErrors.deliveryOrderTypeId}
                      </div>
                    )}
                  </div>
                  <div className="form-control mb-5 w-2/12">
                    <label htmlFor="orderWeight" className="form-label ">
                      გზავნილ(ებ)ის წონა
                    </label>
                    <input
                      id="orderWeight"
                      placeholder="0"
                      className="form-input"
                      type="number"
                      min={0.1}
                      name="weight"
                      value={orderInfo.weight}
                      onChange={handleOrderInfoChange}
                    />
                    {orderInfoErrors.weight && (
                      <div className="text-danger text-[12px]/[16px]">
                        {orderInfoErrors.weight}
                      </div>
                    )}
                  </div>
                  <div className="form-control mb-5 w-2/12">
                    <label htmlFor="quantity" className="form-label ">
                      რაოდენობა
                    </label>
                    <input
                      id="quantity"
                      placeholder="0"
                      className="form-input"
                      type="number"
                      min={1}
                      name="pieceQuantity"
                      value={orderInfo.pieceQuantity}
                      onChange={handleOrderInfoChange}
                    />
                    {orderInfoErrors.pieceQuantity && (
                      <div className="text-danger text-[12px]/[16px]">
                        {orderInfoErrors.pieceQuantity}
                      </div>
                    )}
                  </div>
                  <div className="form-control mb-5 w-2/12">
                    <label htmlFor="insuranceItemPrice" className="form-label ">
                      გზავნილის შეფასება
                    </label>
                    <input
                      id="insuranceItemPrice"
                      placeholder="0"
                      className="form-input"
                      type="number"
                      min={0.1}
                      name="insuranceItemPrice"
                      value={orderInfo.insuranceItemPrice}
                      onChange={handleOrderInfoChange}
                    />
                    {orderInfoErrors.insuranceItemPrice && (
                      <div className="text-danger text-[12px]/[16px]">
                        {orderInfoErrors.insuranceItemPrice}
                      </div>
                    )}
                  </div>
                  <div className="form-control mb-5 w-3/12">
                    <label htmlFor="packageType" className="form-label">
                      პაკეტის ტიპი
                    </label>
                    <div className="flex flex-wrap gap-4">
                      {packageTypes.map((type) => (
                        <label key={type.id} className="flex items-center">
                          <input
                            type="radio"
                            name="packageType"
                            value={type.id}
                            checked={orderInfo.packageTypeId === type.id}
                            onChange={() =>
                              setOrderInfo({
                                ...orderInfo,
                                packageTypeId: type.id,
                              })
                            }
                            className="form-radio text-blue-600"
                          />
                          <span className="ml-2">{type.value}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                {orderInfo.packageTypeId == 2 && (
                  <>
                    <div className="flex justify-end space-x-4">
                      <div className="form-control mb-5 w-1/5"></div>
                      <div className="form-control mb-5 w-1/5"></div>
                      <div className="form-control mb-5 w-1/5"></div>
                      <div className="form-control mb-5 w-1/5"></div>
                      <div className="form-control mb-5 w-1/5">
                        <label htmlFor="volumeWeight" className="form-label ">
                          მოცულობითი წონა
                        </label>
                        <input
                          id="volumeWeight"
                          placeholder="0"
                          className="form-input"
                          disabled
                          type="number"
                          min={0.1}
                          name="volumeWeight"
                          value={orderInfo.volumeWeight}
                        />
                        {orderInfoErrors.volumeWeight && (
                          <div className="text-danger text-[12px]/[16px]">
                            {orderInfo.volumeWeight}
                          </div>
                        )}
                      </div>
                    </div>
                    {pieces.map((piece, index) => (
                      <div key={index} className="flex space-x-4">
                        <div className="form-control mb-5 w-1/4">
                          <label
                            htmlFor={`pieceLength-${index}`}
                            className="form-label"
                          >
                            სიგრძე
                          </label>
                          <input
                            id={`pieceLength-${index}`}
                            placeholder="0"
                            className="form-input"
                            type="number"
                            min={0.1}
                            name="length"
                            value={piece.length || ""}
                            onChange={(e) => handlePieceInputChange(e, index)}
                          />
                          {pieceErrors[`length-${index}`] && (
                            <div className="text-danger text-[12px]/[16px]">
                              {pieceErrors[`length-${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="form-control mb-5 w-1/4">
                          <label
                            htmlFor={`pieceWidth-${index}`}
                            className="form-label"
                          >
                            სიგანე
                          </label>
                          <input
                            id={`pieceWidth-${index}`}
                            placeholder="0"
                            className="form-input"
                            type="number"
                            min={0.1}
                            name="width"
                            value={piece.width || ""}
                            onChange={(e) => handlePieceInputChange(e, index)}
                          />
                          {pieceErrors[`width-${index}`] && (
                            <div className="text-danger text-[12px]/[16px]">
                              {pieceErrors[`width-${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="form-control mb-5 w-1/4">
                          <label
                            htmlFor={`pieceHeight-${index}`}
                            className="form-label"
                          >
                            სიმაღლე
                          </label>
                          <input
                            id={`pieceHeight-${index}`}
                            placeholder="0"
                            className="form-input"
                            type="number"
                            min={0.1}
                            name="height"
                            value={piece.height || ""}
                            onChange={(e) => handlePieceInputChange(e, index)}
                          />
                          {pieceErrors[`height-${index}`] && (
                            <div className="text-danger text-[12px]/[16px]">
                              {pieceErrors[`height-${index}`]}
                            </div>
                          )}
                        </div>
                        <div className="form-control mb-5 w-1/4">
                          <label
                            htmlFor={`pieceVolume-${index}`}
                            className="form-label"
                          >
                            მოცულობითი წონა
                          </label>
                          <input
                            id={`pieceVolume-${index}`}
                            placeholder="0"
                            className="form-input"
                            type="number"
                            min={0.1}
                            disabled
                            name="pieceVolume"
                            value={piece.pieceVolume || ""}
                          />
                        </div>
                      </div>
                    ))}
                  </>
                )}

                <div className="flex  space-x-4">
                  <div className="form-control mb-5 w-1/4">
                    <label htmlFor="paymentMethod" className="form-label">
                      გადახდის მეთოდი
                    </label>
                    <div className="flex flex-col">
                      {peymentMethods.map((method) => {

                        const hideInvoice =
                          !isLoggedIn ||
                          !user ||
                          !user.isConfirmed ||
                          user.userTypeId != 2;

                        return (
                          <React.Fragment key={method.id}>
                            {/* თუ ფიზიკური პირია მაშინ ინვოისი არ უნდა უჩანდეს */}
                            {method.id == 1 &&
                              (hideInvoice) ? null : (
                              <label
                                key={method.id}
                                className="flex items-center"
                              >
                                <input
                                  type="radio"
                                  name="paymentMethod"
                                  value={method.id}
                                  checked={
                                    orderInfo.paymentMethodId === method.id
                                  }
                                  onChange={(e) =>
                                    setOrderInfo({
                                      ...orderInfo,
                                      paymentMethodId: method.id,
                                    })
                                  }
                                  className="form-radio"
                                />
                                <span className="ml-2">{method.value}</span>
                              </label>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {orderInfoErrors.paymentMethodId && (
                        <div className="text-danger text-[12px]/[16px]">
                          {orderInfoErrors.paymentMethodId}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-control mb-5 w-1/4">
                    <label htmlFor="deliveryMethod" className="form-label">
                      მიწოდების მეთოდი
                    </label>
                    <div className="flex flex-col">
                      {deliveryMethods.map((method) => (
                        <label key={method.id} className="flex items-center">
                          <input
                            type="radio"
                            name="deliveryMethod"
                            value={method.id}
                            checked={orderInfo.deliveryMethodId === method.id}
                            onChange={(e) =>
                              setOrderInfo({
                                ...orderInfo,
                                deliveryMethodId: method.id,
                              })
                            }
                            className="form-radio"
                          />
                          <span className="ml-2">{method.value}</span>
                        </label>
                      ))}
                      {orderInfoErrors.deliveryMethodId && (
                        <div className="text-danger text-[12px]/[16px]">
                          {orderInfoErrors.deliveryMethodId}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-control mb-5 w-1/2">
                    <label htmlFor="comment" className="form-label">
                      შიგთავსი
                    </label>
                    <textarea
                      id="comment"
                      placeholder="გზავნილის შიგთავსი. მაგ.: დოკუმენტი, წერილი, პრინტერი, ა.შ. …"
                      className="form-input"
                      name="comment"
                      value={orderInfo.comment}
                      onChange={handleOrderInfoChange}
                      rows="3"
                    />
                    {orderInfoErrors.comment && (
                      <div className="text-danger text-[12px]/[16px]">
                        {orderInfoErrors.comment}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="grid xxl:grid-cols-3 sm:grid-cols-3 grid-cols-3 gap-2 mt-10">
              <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
                <IconPackageExport className="w-[36px] h-[36px]" />
                <h5 className="my-2 text-[20px]/[26px] font-medium">
                  გამგზავნი
                </h5>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>სახელი :</span>
                  <span>{sender?.name}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>პირადი ნომერი :</span>
                  <span>{sender?.idNumber}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>ქალაქი :</span>
                  <span>{selectedCities.senderCityName}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>მისამართი :</span>
                  <span>{sender?.address}</span>
                </div>
                {sender.contactName && (
                  <div className="flex flex-wrap justify-between text-font-color-100">
                    <span>საკონტაქტო პირი :</span>
                    <span>{sender?.contactName}</span>
                  </div>
                )}
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>ტელეფონი :</span>
                  <span>{sender?.contactPhone}</span>
                </div>
              </div>
              <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
                <IconPackageImport className="w-[36px] h-[36px]" />
                <h5 className="my-2 text-[20px]/[26px] font-medium">მიმღები</h5>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>სახელი :</span>
                  <span>{receiver?.name}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>პირადი ნომერი :</span>
                  <span>{receiver?.idNumber}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>ქალაქი :</span>
                  <span>{selectedCities.receiverCityName}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>მისამართი :</span>
                  <span>{receiver?.address}</span>
                </div>
                {receiver.contactName && (
                  <div className="flex flex-wrap justify-between text-font-color-100">
                    <span>საკონტაქტო პირი :</span>
                    <span>{receiver?.contactName}</span>
                  </div>
                )}
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>ტელეფონი :</span>
                  <span>{receiver?.contactPhone}</span>
                </div>
              </div>
              <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
                <IconListDetails className="w-[36px] h-[36px]" />
                <h5 className="my-2 text-[20px]/[26px] font-medium">
                  ტვირთის აღწერა
                </h5>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>გზავნილის წონა (კგ) :</span>
                  <span>{orderInfo?.weight}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>რაოდენობა :</span>
                  <span>{orderInfo?.pieceQuantity}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>გზავნილის შეფასება :</span>
                  <span>{orderInfo?.insuranceItemPrice}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>მოცულობითი წონა :</span>
                  <span>{parseFloat(orderInfo?.volumeWeight).toFixed(5)}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>სერვისი :</span>
                  <span>{selectedDeliveryOrderType}</span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>გადახდის მეთოდი :</span>
                  <span>
                    {
                      peymentMethods.find(
                        (pay) => pay.id == orderInfo.paymentMethodId
                      )?.value
                    }
                  </span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span>მიტანის მეთოდი :</span>
                  <span>
                    {
                      deliveryMethods.find(
                        (pay) => pay.id == orderInfo.deliveryMethodId
                      )?.value
                    }
                  </span>
                </div>
                <div className="flex flex-wrap justify-between text-font-color-100">
                  <span className="text-red-600 text-lg font-semibold text-lg">
                    გადასახდელი თანხა :
                  </span>
                  <span className="text-red-600 text-lg font-semibold text-lg">
                    {calculatedPrice}
                  </span>
                </div>
              </div>
            </div>
            {pieces.length > 0 && pieces[0].length && (
              <div className="grid xxl:grid-cols-4 sm:grid-cols-4 grid-cols-4 gap-2 mt-10">
                {pieces.map((piece, index) => (
                  <div
                    key={index}
                    className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color"
                  >
                    <IconPackage className="w-[28px] h-[28px]" />
                    <h5 className="my-2 text-[20px]/[26px] font-medium">
                      ნივთი {piece.id}
                    </h5>
                    <div className="flex flex-wrap justify-between text-font-color-100">
                      <span>სიმაღლე (სმ) :</span>
                      <span>{piece?.height}</span>
                    </div>
                    <div className="flex flex-wrap justify-between text-font-color-100">
                      <span>სიგრძე (სმ) :</span>
                      <span>{piece?.length}</span>
                    </div>
                    <div className="flex flex-wrap justify-between text-font-color-100">
                      <span>სიგანე (სმ) :</span>
                      <span>{piece?.width}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="flex justify-end mt-10">
              <RecaptchaComponent reset={resetCaptcha} />
            </div>

            {/* <GeneratePDF
              deliveryMethods={deliveryMethods}
              orderInfo={orderInfo}
              peymentMethods={peymentMethods}
              pieces={pieces}
              sender={sender}
              receiver={receiver}
              selectedCities={selectedCities}
              selectedDeliveryOrderType={selectedDeliveryOrderType}
            /> */}
          </>
        );
      default:
        return "Unknown stepIndex";
    }
  };

  return (
    <>
      {loading && <Loader />}
      {isLoading && <Loader />}
      <CustomAlert {...alertConfig} />
      {createEventModal && (
        <TwoFactorModal
          askSms={!isLoggedIn}
          authType={"deliveryRequest"}
          setCreateEventModal={openCreateEventModal}
          isLoggedIn={isLoggedIn}
          formData={formData}
          setFormData={setFormData}
          packageData={{
            sender: sender,
            receiver: receiver,
            orderInfo: {
              ...orderInfo,
              payerSideId:
                iAmType == 2 && receiver.clientTypeId == "1" ? 1 : iAmType,
            },
            pieces: pieces,
          }}
          setAlertConfig={setAlertConfig}
          setPackageModal={openDeliveryModal}
        />
      )}
      {openDeliveryAddedModal && (
        <>
          <DeliveryAddedModal
            sender={sender}
            receiver={receiver}
            orderInfo={orderInfo}
            pieces={pieces}
            selectedCities={selectedCities}
            selectedDeliveryOrderType={selectedDeliveryOrderType}
            deliveryMethods={deliveryMethods}
            peymentMethods={peymentMethods}
            trackingNumber={trackingNumber}
            docUrl={docUrl}
            onClose={handleFinalModalClose}
          />
        </>
      )}
      {/* {isLoggedIn && (
        <>
          <div className="w-full flex justify-end items-center mb-[10px]">
            <div
              style={{ cursor: "pointer" }}
              title="პროფილი"
              onClick={() => navigate("/packages")}
            >
              <IconUser className="w-[36px] h-[36px]"></IconUser>
            </div>
          </div>
        </>
      )} */}
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          return (
            <Step key={label} onClick={() => index < activeStep && setActiveStep(index)} style={{ cursor: index < activeStep ? "pointer" : "default" }}>
              <StepLabel
                sx={{
                  "& .MuiStepIcon-root": {
                    color:
                      activeStep === index
                        ? "#e05170 !important"
                        : activeStep > index
                          ? "#4c3575 !important"
                          : "#b9b3a8 !important",
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <>
        {TabRenderer()}
        {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
          {activeStep > 0 &&
            <button
              className="btn btn-md btn-secondary"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              უკან
            </button>}
          <Box sx={{ flex: "1 1 auto" }} />

          <button
            type="button"
            className="btn btn-md btn-primary"
            onClick={handleNext}
          >
            {activeStep === steps.length - 1 ? "დასრულება" : "შემდეგი"}
          </button>
        </Box>
      </>

    </>
  );
};

export default DeliveryRequest;